import React from 'react';
import { AdminProvider } from '../admin/AdminContext';
import BlogManagerView from '../admin/pages/BlogManagerView';

export default function BlogAdmin() {
  return (
    <AdminProvider>
      <BlogManagerView />
    </AdminProvider>
  );
}